import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { getKey } from '../utils/uid';
import { Component } from '../component';
import { getFilterTree } from '../utils/tree';
export default (function (Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(CascaderFilter, _Component);

    var _super = _createSuper2(CascaderFilter);

    function CascaderFilter(props) {
      var _this;

      _classCallCheck(this, CascaderFilter);

      _this = _super.call(this, props);
      _this.firstMatchNode = void 0;
      _this.timer = void 0;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      _this.state = {
        filterText: '',
        filter: null
      };
      return _this;
    }

    _createClass(CascaderFilter, [{
      key: "getData",
      value: function getData() {
        var _this2 = this;

        var _this$props = this.props,
            data = _this$props.data,
            childrenKey = _this$props.childrenKey,
            keygen = _this$props.keygen;
        var filter = this.state.filter;
        if (!filter) return data;
        return getFilterTree(data, filter, undefined, function (node) {
          return getKey(node, keygen);
        }, childrenKey, true, function (node) {
          if (_this2.firstMatchNode) return;
          _this2.firstMatchNode = node;
        });
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(filterText) {
        var _this3 = this;

        var _this$props2 = this.props,
            filterDelay = _this$props2.filterDelay,
            onFilter = _this$props2.onFilter;
        if (this.timer) clearTimeout(this.timer);
        this.firstMatchNode = null;

        if (filterText.length === 0) {
          this.setState({
            filter: null,
            filterText: filterText
          });
          return;
        }

        this.timer = setTimeout(function () {
          var fn = onFilter(filterText);

          if (typeof fn === 'function') {
            _this3.setState({
              filter: fn,
              filterText: filterText
            });
          }
        }, filterDelay);
      }
    }, {
      key: "render",
      value: function render() {
        var onFilter = this.props.onFilter;
        var _this$state = this.state,
            filterText = _this$state.filterText,
            filter = _this$state.filter;
        if (!onFilter) return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, this.props, {
            sourceData: this.props.data
          }))
        );
        var data = this.getData();
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, this.props, {
            data: data,
            sourceData: this.props.data,
            filterText: filterText,
            onFilter: this.handleFilter,
            filterDataChange: filter,
            firstMatchNode: this.firstMatchNode
          }))
        );
      }
    }]);

    return CascaderFilter;
  }(Component), _class.defaultProps = {
    filterDelay: 400,
    childrenKey: 'children'
  }, _temp;
});